<template>
  <div class="container">
    <h1 class="subs-title">{{ organizationText(getTitle()) }}</h1>
    <text-field v-model="form.name" :validator="$v.form.name" :label="adminText('organizationAll.subscription_name_e7d80671', 'Subscription name*')" />
    <div class="input-container">
      <datetime-field
        v-model="form.from"
        :validator="$v.form.from"
        style="width: 100%"
        :label="adminText('organizationAll.from_4a2da276', 'From*')"
        :min="new Date().toString()"
        :error-messages="{
          minDate: adminText('organizationAll.start_date_must_be_a_future_date_49b63d67', 'Start date must be a future date'),
          maxDate: adminText('organizationAll.start_date_should_be_before_the_end_of_the_ev_d4de23c0', 'Start date should be before the end of the event'),
        }"
      />
      <datetime-field
        v-model="form.to"
        :validator="$v.form.to"
        style="width: 100%"
        :label="adminText('organizationAll.to_c2fdddd0', 'To*')"
        :min="form.from ? form.from.toString() : new Date().toString()"
        :error-messages="{
          minDate: adminText('organizationAll.end_date_should_not_be_before_the_start_of_th_0753b659', 'End date should not be before the start of the event'),
        }"
      />
    </div>
    <div class="input-container">
      <text-field
        v-model.number="form.price"
        :validator="$v.form.price"
        type="number"
        step="0.01"
        :label="adminText('organizationAll.price_eur_444903ee', 'Price (EUR)*')"
      />
    </div>
    <textarea-field
      v-model="form.description"
      :validator="$v.form.description"
      :label="adminText('organizationAll.description_55f8ebc8', 'Description')"
      height="13.75rem"
    />
    <h2 class="second-title">{{ adminText('organizationAll.included_events_33330eed', 'Included events') }}</h2>
    <p class="description">
      {{ adminText('organizationAll.you_can_add_tickets_for_performances_by_event_9894b85a', 'You can add tickets for performances by events name or by preferences.') }}
    </p>
    <div v-for="(item, index) in $v.form.couponItems.$each.$iter" :key="item.externalId">
      <subscription-item
        :coupon-item="item"
        :event-templates="eventTemplates"
        :interests="interests"
        :index="parseInt(index)"
        :vs="item"
        @updateCouponItem="updateCouponItem($event)"
        @removeSubscriptionItem="removeSubscriptionItem(item.externalId)"
      />
    </div>

    <main-button style="margin-top: 8px; width: 290px" flat depressed @click="addSubscriptionItem">
      <span class="add-symbol">+</span>{{ adminText('organizationAll.add_ticket_for_event_269f7963', 'Add ticket for event') }}
    </main-button>
    <div class="buttons-wrapper" style="margin-top: 58px">
      <main-button :text="adminText('organizationAll.cancel_1507c40f', 'CANCEL')" flat depressed @click="$emit('cancel')" />
      <div class="buttons">
        <main-button :text="organizationText(buttonName)" @click="handleCreate" />
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import { cloneDeep } from 'lodash'
import { required } from 'vuelidate/lib/validators'
import { submitGuard } from '@/utils'
import { v4 as uuid } from 'uuid'
import SubscriptionItem from '@/components/organizations/subscriptions/SubscriptionItem.vue'

export default {
  mixins: [OrganizationLocalization],
  name: 'create-or-edit-subscription-plan',
  components: {
    SubscriptionItem,
  },
  props: {
    organizationSlug: {
      type: String,
    },
    initialValue: {
      type: Object,
      default: () => {},
    },
    eventTemplates: {
      type: Array,
      default: () => [],
    },
    interests: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: { couponItems: [], ...cloneDeep(this.initialValue) },
      buttonName: 'Create plan',
      emitType: 'create',
      attendeeFields: {},
    }
  },
  // TODO - Finish validations
  validations() {
    return {
      form: {
        name: { required },
        price: { required },
        from: { required },
        to: { required },
        couponItems: {
          $each: {
            ticketAmount: { required },
            type: { required },
          },
        },
      },
    }
  },
  methods: {
    getTitle() {
      if (Object.keys(this.initialValue).length) {
        this.buttonName = 'Update'
        this.emitType = 'update'

        return 'Edit Package Plan'
      } else {
        return 'Create Package Plan'
      }
    },
    addSubscriptionItem() {
      this.form.couponItems.push({
        externalId: uuid(),
      })
    },
    removeSubscriptionItem(externalId) {
      this.form.couponItems.splice(
        this.form.couponItems.findIndex(item => item.externalId === externalId),
        1,
      )
    },
    updateCouponItem(info) {
      this.form.couponItems = this.form.couponItems.map(ci =>
        ci.externalId === info.externalId ? info : ci,
      )
    },
    handleCreate() {
      submitGuard(this, () => this.$emit(this.emitType, this.form))
    },
  },
}
</script>

<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 43.75rem;
}
.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.input-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  column-gap: 1.5rem;
}
.second-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #ff4c00;
  margin-bottom: 0.75rem;
  margin-top: 3rem;
}
</style>
